export default __webpack_public_path__ + "static/media/comingsoon.ccfa95f0.jpg";